// destino-sesion.js
//
// A dónde va una sesión ya iniciada, según lo que /api/user/me/ dice de la
// cuenta. UNA regla para todas las puertas (login con clave, entrar directo a
// /, /waiting-for-access), porque cuando cada puerta decidía sola, una de ellas
// se equivocaba:
//
// Antes, Authentication.js mandaba a /waiting-for-access a TODO usuario sin
// `has_access`. Con el alta self-service (#878) eso incluía al que acababa de
// crear su cuenta, se fue a buscar sus papeles (la bienvenida se lo pidió) y
// volvió al día siguiente: aterrizaba en "Por ahora trabajamos solo con
// clientes particulares…" sin un solo botón. El revisor lo midió el
// 08-sep-2026 en desktop y en mobile.
//
// Regla:
//   - con acceso (o admin)            → /home, como siempre.
//   - sin acceso y todavía le falta
//     algo que solo él puede poner
//     (NOT_SUBMITTED / REJECTED)      → el wizard, /perfil/verificacion.
//   - sin acceso y ya subió todo
//     (PENDING)                       → /waiting-for-access: espera al humano.
//
// `has_access` manda sobre la verificación a propósito: una cuenta demo o
// habilitada a mano no se ve forzada a nada, igual que en ProfileCompletionGate.
//
// Desde el 09-sep-2026 este destino es también el de la cuenta RECIÉN creada:
// la bienvenida dejó de ser una pantalla aparte (/bienvenida) y es el paso 0
// del wizard. O sea que las tres puertas —alta con Google, alta con clave, y
// volver al día siguiente— aterrizan en el mismo lugar, y el wizard decide por
// cuál de sus cuatro pasos entra según lo que la cuenta ya haya hecho (ver
// helpers/pasos-verificacion.js).

// #1401 (R21): con acceso a UN SOLO módulo (Turno) y no superuser, la sesión
// aterriza directo en /turno en vez de /home — no tiene sentido mostrarle un
// menú con un solo módulo prendido a quien recién entró con la prueba corta.
// La lista de módulos sale de las claves `can_access_*` PRESENTES en el
// objeto (igual que `sin_modulos` en el backend, `serializers.py`): así un
// módulo nuevo entra solo a la cuenta en vez de quedar afuera hasta que
// alguien actualice una lista a mano acá.
import { reintroPorMostrar } from "./reintro";

const CAN_ACCESS_PREFIX = "can_access_";

const tieneSoloTurno = (user) => {
  if (!user || user.is_superuser) return false;
  if (!user.can_access_turno) return false;
  return Object.keys(user)
    .filter((k) => k.startsWith(CAN_ACCESS_PREFIX) && k !== "can_access_turno")
    .every((k) => !user[k]);
};

export const destinoSegunCuenta = (user) => {
  if (!user) return "/authentication";
  // Cubre R9 — .claude/specs/rescate-inactivos/. Cuenta del rescate: aterriza
  // en el onboarding aunque tenga acceso. Una sola vez por sesión del navegador
  // (helpers/reintro.js): el wizard llama a esta función al salir, y sin la
  // marca lo devolvería a sí mismo.
  if (reintroPorMostrar(user)) return "/perfil/verificacion";
  if (user.has_access || user.is_superuser) {
    return tieneSoloTurno(user) ? "/turno" : "/home";
  }
  const status = user.professional_profile?.verification_status || "NOT_SUBMITTED";
  if (status === "PENDING") return "/waiting-for-access";
  return "/perfil/verificacion";
};
